// extracted by mini-css-extract-plugin
module.exports = {"wrap":"styles_wrap__1AGe-","photo":"styles_photo__3so5F","content":"styles_content__8PqVu","header":"styles_header__LsaDe","title":"styles_title__2Wprw","btn":"styles_btn__mjAj4"};